import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('management-reports-global', storeModule.createStoreModule('management-reports-global'))
